// src/modules/absences/domain/Absence.ts
export class Absence {
  uuid: string;
  start: string;
  end: string;
  reason: string;
  status: string;
  fotoJustificante?: File | string | null;
  lista_motivos?: string | null;
  tipoAusencia?: string | null;
  sendEmailNotification?: boolean;
  user_id?: number;

  constructor(uuid: string, start: string, end: string, reason: string, status: string = 'pending', fotoJustificante?: File | string | null, lista_motivos?: string | null, tipoAusencia?: string | null) {
    this.uuid = uuid;
    this.start = start;
    this.end = end;
    this.reason = reason;
    this.status = status;
    this.fotoJustificante = fotoJustificante;
    this.lista_motivos = lista_motivos;
    this.tipoAusencia = tipoAusencia;
    this.sendEmailNotification = false;
  }
}
